import { subclass } from "@arcgis/core//core/accessorSupport/decorators";
import Accessor from "@arcgis/core/core/Accessor";

@subclass("AppTypeTileViewModel")
export default class AppTypeTileViewModel extends Accessor {

  constructor(params?: any) {
    super(params);
  }

}